import { Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../models/response.model'

@Injectable({ providedIn: 'root' })
export class ContratoItemServicoAdicionalService {
  private baseUrl = environment.baseUrl
  private resource = 'ContratoItemServicoAdicional'

  constructor(private httpClient: HttpClient) {}

  public create(payload: {
    contratoItemId: string
    dataServico: string
    servicoAdicionalId: number
    quantidade: number
    taxa: number
    valorUnitario: number
    valorTotal: number
    observacao?: string | null
  }): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      payload,
    )
  }

  public remove(id: string): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/remove/${id}`,
      {},
    )
  }

  public getValorTotal(contratoItemId: string): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/ValorTotal/ContratoItemId/${contratoItemId}`,
    )
  }

  public listPaginated(contratoItemId: string, page = 1, rows = 10): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/ContratoItem/listpaginated/${contratoItemId}?pageNumber=${page}&pageSize=${rows}`,
    )
  }
}
